export {
  default as pickleball,
  ReactComponent as Pickleball,
} from '@assets/icons/features-and-amenities/pickleball.svg'    
